import axios from 'axios';

// Base API configuration
const API_BASE_URL = process.env.REACT_APP_API_URL;

// Validate that API URL is set
if (!API_BASE_URL) {
  console.error('REACT_APP_API_URL is not set in environment variables. Please create a .env file with REACT_APP_API_URL=http://localhost:8000/api');
  throw new Error('REACT_APP_API_URL environment variable is required');
}

// Create axios instance with default configuration
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000, // Increased timeout for LimeSurvey API calls
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Request interceptor to add authentication token
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage or sessionStorage
    const token = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add CSRF token for Laravel Sanctum
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (csrfToken) {
      config.headers['X-CSRF-TOKEN'] = csrfToken;
    }
    
    // Don't set Content-Type for FormData - let browser set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle authentication errors
    if (error.response?.status === 401) {
      // Check if user was suspended
      const isSuspended = error.response?.data?.suspended === true;
      const suspensionMessage = error.response?.data?.message;
      
      // Clear stored tokens
      localStorage.removeItem('auth_token');
      sessionStorage.removeItem('auth_token');
      
      // If suspended, store message in sessionStorage to show on login page
      if (isSuspended && suspensionMessage) {
        sessionStorage.setItem('suspension_message', suspensionMessage);
      }
      
      // Redirect to login page or show login modal
      window.location.href = '/login';
    }
    
    // Handle network errors
    if (!error.response) {
      console.error('Network Error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// Export the axios instance
export default api;
